export default __webpack_public_path__ + "static/media/Download.686e55ab.svg";